"use client";

import { css } from "styled-components";
import { kebabCase } from "../common";

import { mediaDesktop, mediaTablet } from "../responsive";
import { fonts } from "@/common/theme";

import { minFontSize } from "./vars";

export const setVh = (value) => `calc(var(--vh, 1vh) * ${value})`;

export const fullHeight = css`
  height: ${setVh(100)};
  height: 100svh;
`;

const getStyleString = (key, value, deviceType, isImportant, locale) => {
  const isRemUnit = ["fontSize", "wordSpacing"].includes(key);
  const isEmUnit = ["letterSpacing"].includes(key);
  const isObject = [
    "fontSize",
    "lineHeight",
    "fontWeight",
    "letterSpacing",
  ].includes(key);
  const isFontFamily = key === "fontFamily";
  const isFontSize = key === "fontSize";

  const parsedKey = kebabCase(key);
  const parsedValue =
    isObject && !Number.isFinite(value)
      ? value[deviceType]
      : isFontFamily
      ? fonts.face[
          typeof value === "object" ? value[locale] || value.default : value
        ]
      : value;
  const parsedUnit =
    (isRemUnit || isEmUnit) && parsedValue ? (isRemUnit ? "rem" : "em") : "";

  let parsedValueWithUnit = `${parsedValue}${parsedUnit}`;
  if (isFontSize && Number.isFinite(minFontSize[deviceType])) {
    parsedValueWithUnit = `max(${parsedValueWithUnit}, ${minFontSize[deviceType]}px)`;
  }

  return `${parsedKey}: ${parsedValueWithUnit}${
    isImportant ? " !important" : ""
  };`;
};

export const setTypography = (
  category,
  locale = process.env.DEFAULT_LOCALE,
  isImportant = false
) => css`
  ${Object.entries(fonts.scale[category])
    .map(([key, value]) =>
      getStyleString(key, value, "mobile", isImportant, locale)
    )
    .join("\n")}

  ${mediaTablet(css`
    ${Object.entries(fonts.scale[category])
      .filter(([, value]) => value?.tablet !== undefined)
      .map(([key, value]) =>
        getStyleString(key, value, "tablet", isImportant, locale)
      )
      .join("\n")}
  `)}

  ${mediaDesktop(css`
    ${Object.entries(fonts.scale[category])
      .filter(([, value]) => value?.desktop !== undefined)
      .map(([key, value]) =>
        getStyleString(key, value, "desktop", isImportant, locale)
      )
      .join("\n")}
  `)}
`;

export const centerAbsolute = css`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

// TODO: Fix aspect ratio calculation
export const forceAspect = (aspect) => css`
  &::after {
    content: "";
    display: block;
    padding-bottom: ${aspect * 100}%;
  }
  * {
    position: absolute;
  }
`;
